import { Link } from "react-router-dom";
import manninghamLogo from "@/assets/manningham-logo.png";
import hufcLogo from "@/assets/hufc-heidelberg-logo.png.asset.json";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

interface ClubLogo {
  name: string;
  logo: string;
  style?: string;
}

const clubLogos: ClubLogo[] = [
  { name: "Manningham United FC", logo: manninghamLogo },
  { name: "HUFC Miniroos", logo: hufcLogo.url },
];

export const ClubLogoCarousel = () => {
  // When few logos, just center them. Use carousel when there are enough.
  if (clubLogos.length <= 4) {
    return (
      <div className="flex justify-center items-center gap-6">
        {clubLogos.map((club) => (
          <Link key={club.name} to="/clubs" className="group cursor-pointer">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
              <img
                src={club.logo}
                alt={club.name}
                className={`w-full h-full object-contain ${club.style || ""}`}
              />
            </div>
          </Link>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <Carousel
        opts={{ align: "center", loop: true }}
        className="w-full max-w-md"
      >
        <CarouselContent className="-ml-2">
          {clubLogos.map((club) => (
            <CarouselItem key={club.name} className="pl-2 basis-1/4 flex items-center justify-center">
              <Link to="/clubs" className="group cursor-pointer">
                <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center">
                  <img
                    src={club.logo}
                    alt={club.name}
                    className={`w-full h-full object-contain ${club.style || ""}`}
                  />
                </div>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className="hidden sm:flex -left-12" />
        <CarouselNext className="hidden sm:flex -right-12" />
      </Carousel>
    </div>
  );
};
